import type { FC, PropsWithChildren } from 'react'
import { createContext, useContext } from 'react'

import { useLazyAgoraClient } from '@core/agoraRTC/hooks/useLazyAgoraClient'
import type { AgoraRTCClientWrapper } from '@core/agoraRTC/libs/AgoraRTCClientWrapper'

export const AgoraRTCClientContext = createContext<
  AgoraRTCClientWrapper | undefined
>(undefined)

interface Props {
  /** Whether it should start lazy loading the Agora RTC client. */
  loadClient: boolean
  enableInstantVideo?: boolean
  enableLogUpload?: boolean
}

/** Provides AgoraRTCClientWrapper instance when it is lazy loaded. */
export const AgoraRTCClientProvider: FC<PropsWithChildren<Props>> = ({
  children,
  loadClient,
  enableInstantVideo = false,
  enableLogUpload = false,
}) => {
  const client = useLazyAgoraClient(
    loadClient,
    enableInstantVideo,
    enableLogUpload,
  )

  return (
    <AgoraRTCClientContext.Provider value={client}>
      {children}
    </AgoraRTCClientContext.Provider>
  )
}

/** @returns AgoraRTCClientWrapper from the context. */
export const useAgoraRTCClientContext = () => {
  const client = useContext(AgoraRTCClientContext)

  return client
}
